import { DocumentationErrorIcon } from '@/components/shared/components/ErrorIcon/components/DocumentationErrorIcon';
import { LoanApplicationErrorIcon } from '@/components/shared/components/ErrorIcon/components/LoanApplicationErrorIcon';
import { useUser } from '@/hooks/useUser';

export const ErrorIcon = ({
  errorDetected,
  isDocumentationWithIncidence,
}: {
  errorDetected?: boolean;
  isDocumentationWithIncidence?: boolean;
}) => {
  const { userEntity } = useUser();

  const getErrorType = () => {
    return isDocumentationWithIncidence
      ? ErrorType.DOCUMENTATION_ERROR
      : errorDetected && !userEntity?.isRoleMerchantChannelOrAgent()
      ? ErrorType.LOAN_APPLICATION_ERROR
      : undefined;
  };

  const getErrorIcon = (errorType?: ErrorType) => {
    switch (errorType) {
      case ErrorType.DOCUMENTATION_ERROR:
        return <DocumentationErrorIcon />;
      case ErrorType.LOAN_APPLICATION_ERROR:
        return <LoanApplicationErrorIcon />;
      default:
        return <></>;
    }
  };

  return getErrorIcon(getErrorType());
};

export enum ErrorType {
  DOCUMENTATION_ERROR = 'documentation_error',
  LOAN_APPLICATION_ERROR = 'loan_application_error',
}
